import type { ComponentPropsWithoutRef } from 'react';

import { cn } from '../lib/cn';

export interface ImageProps extends ComponentPropsWithoutRef<'img'> {}

export function Image({ className, ...restProps }: ImageProps) {
  return <img className={cn(className)} loading='lazy' {...restProps} />;
}
